/*
 *
 * PracticePage constants
 *
 */

export const DEFAULT_ACTION = "app/PracticePage/DEFAULT_ACTION";

/**
 * Clinics
 */
export const GET_PRACTICES_ACTION = "app/PracticePage/GET_PRACTICES_ACTION";
export const GET_PRACTICES_FAILED_ACTION =
  "app/PracticePage/GET_PRACTICES_FAILED_ACTION";
export const GET_PRACTICES_SUCCESS_ACTION =
  "app/PracticePage/GET_PRACTICES_SUCCESS_ACTION";

/**
 * Select practice
 */
export const SELECT_PRACTICE_ACTION = "app/PracticePage/SELECT_PRACTICE_ACTION";

/**
 * Urls
 */
export const PRACTICES_URL = "/practices";
